import { FunctionComponent } from 'react';
import { ProductName } from 'domain/product/enums/ProductName';
import ProductUsers from 'components/common/Product/ProductUsers/ProductUsers';

const Users: FunctionComponent = () => (
	<ProductUsers productName={ProductName.Alerts} />
);

export default Users;
